import { type Href } from 'expo-router';
import { View } from 'react-native';

import { BrandMark } from '@/components/ui/BrandMark';
import { Button } from '@/components/ui/Button';
import { cn } from '@/components/ui/cn';
import { SIGNUP_OPEN } from '@/lib/constants';

export function LandingNav({
  signInHref,
  getStartedHref,
}: {
  signInHref: Href;
  getStartedHref: Href;
}) {
  return (
    <View className="w-full items-center border-b border-border-strong bg-background px-4 sm:px-6">
      <View className="h-[66px] w-full max-w-[1160px] flex-row items-center justify-between gap-2 sm:gap-4">
        <BrandMark size="md" className="shrink" />

        <View className="shrink-0 flex-row items-center gap-2 sm:gap-4">
          {/* During the beta "Get started" is disabled, so keep "Sign in" visible
              even on narrow viewports — otherwise there's no working auth entry.
              Once signup opens, hide it below md to save space. */}
          <View className={cn(SIGNUP_OPEN && 'hidden md:flex')}>
            <Button variant="ghost" size="sm" label="Sign in" href={signInHref} />
          </View>
          {SIGNUP_OPEN && <Button size="sm" label="Sign up" href={getStartedHref} />}
        </View>
      </View>
    </View>
  );
}
